var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{staticClass:"holamundo",attrs:{"title":"Cargando","active":_vm.popupCarga},on:{"update:active":function($event){_vm.popupCarga=$event}}},[_c('div',{attrs:{"align":"center"}},[_c('img',{staticClass:"mt-2",attrs:{"src":"https://data.prolipadigital.com.ec/archivos/upload/img_plataforma/cargandopdf2.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }